import { Header } from "antd/es/layout/layout";
import { Button } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

const Navbar = ({ onToggleSidebar, collapsed }) => {
  return (
    <Header className="navbar">
      <div>
        <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={onToggleSidebar}
          className="btn-toggle"
        />
        <img
          className="navbar-logo"
          src="/assets/images/bg/logo_wide.png"
          alt=""
        />
      </div>

      {/* <div className="navbar-right">
        <LangSwitch />
      </div> */}
    </Header>
  );
};

export default Navbar;
